// Shared priority color constants used across TasksPage, MomsPage,
// PendingValidationPage, TaskDetailsPage, BulkTaskUploadModal, etc.

export const PRIORITY_COLORS = {
  High:   "#dc2626",
  Medium: "#d97706",
  Low:    "#16a34a",
};

export const PRIORITY_BG = {
  High:   "#fff1f1",
  Medium: "#fffbeb",
  Low:    "#f0fdf4",
};

export const PRIORITY_OPTIONS = ["High", "Medium", "Low"];

// Darker / more saturated variant used for priority tags in detail views
export const PRIORITY_TAG_BG = {
  High:   "#fee2e2",
  Medium: "#fef3c7",
  Low:    "#d1fae5",
};

export const PRIORITY_TAG_COLORS = {
  High:   "var(--danger-text)",
  Medium: "var(--warn-text)",
  Low:    "var(--success-text)",
};

export const STATUS_COLORS = {
  Open:            "var(--text-2)",
  InProgress:      "#f59e0b",
  Hold:            "#eab308",
  UnderValidation: "#8b5cf6",
  Completed:       "#16a34a",
};
